import React from 'react'

import { MintField as Field } from '@/domain/liquidity'
import { useStableOnChainPairData } from '@/features/market/useStableOnChainPairData'
import type { AddLiquidityControllerResult } from '@/features/liquidity/useAddLiquidityController'

import { LiquidityNutrimaticMobileAddView } from './mobile/LiquidityNutrimaticMobileAddView'
import { LiquidityNutrimaticMobileShell } from './mobile/LiquidityNutrimaticMobileShell'
import { LiquidityNutrimaticUnifiedTabletShell } from './hub/LiquidityNutrimaticUnifiedTabletShell'

/**
 * Composición Nutri-Matic para añadir liquidez.
 * Desktop (xl+): tableta flotante con gráfica + instrumento LP.
 * Móvil: shell simplificado full-viewport.
 */
export function LiquidityNutrimaticAddLayout({ controller }: { controller: AddLiquidityControllerResult }) {
  const pairData = useStableOnChainPairData(
    controller.currencies[Field.CURRENCY_A],
    controller.currencies[Field.CURRENCY_B],
  )

  return (
    <>
      <div className="hidden min-h-0 flex-1 flex-col lg:flex">
        <LiquidityNutrimaticUnifiedTabletShell mode="add" controller={controller} pairData={pairData} />
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden lg:hidden">
        <LiquidityNutrimaticMobileShell>
          <LiquidityNutrimaticMobileAddView controller={controller} />
        </LiquidityNutrimaticMobileShell>
      </div>
    </>
  )
}
